import React from 'react'

const PasswordViewUI = ({context, messageList}) =>
  <div>
    **********
  </div>

export default PasswordViewUI
